import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  IconButton,
  Stack,
  Text
} from '@chakra-ui/react'
import {
  ArrowIcon,
  ResizeIcon,
  ShrinkIcon
} from 'assets/icons'
import { LoadingSpinier } from 'common/Loading'
import {
  PENDING,
  REJECTED
} from 'utils/constants'
import { isNotMobile } from 'utils/helpers'
import { BlogList } from 'components/Notifications/CommunityBlogs/BlogList'
import { Comments } from 'components/Notifications/CommunityBlogs/Comments'
import { COLORS } from 'utils/styles'
import {
  getNotificationMessage,
  setCloseChatModal,
  setBlogRepostData,
  setBlogRepostParent,
  setComments,
  setNewPostsOption,
  getComments,
  setHideNotification,
  setHideChat,
  setHideDrawerAnimation,
  showCurrentChatFriendMarkerCoordinate
} from 'store'
import { StyledMotionBox } from '../styled'

export const ContentForBlogPreview = ({
  adminNotifications,
  animateMarkerFilter,
  data,
  blogRepostData,
  blogRepostParent,
  chosenBlogIndex,
  chosenNotifBlog,
  closeDrawer,
  comments,
  commentsOption,
  getCommentsStatus,
  getPostsStatus,
  hoveringChevron,
  postCommentsStatus,
  postsOption,
  profileItem,
  setHoveringChevron,
  setWiden,
  setWidenAnimation,
  subscribeToProfileStatus,
  widen,
  widenAnimation,
  activeProfile,
  putCommentsStatus,
  newPostsOption
}) => {
  const dispatch = useDispatch()
  const from = 'repost-content'

  const shouldWiden = () => widen && widenAnimation && isNotMobile()

  const getDrawerHeight = () => {
    let drawerHeight = window.innerHeight - 120

    if (postsOption.type === 'marker') {
      drawerHeight -= '26'
    }

    return drawerHeight + 'px'
  }

  const goToHeaderOriginalPos = () => {
    document.querySelectorAll('.blogStartItem' + chosenBlogIndex).forEach((e) => {
      if (e.closest('.' + from)) {
        setTimeout(() => e.scrollIntoView({ behavior: 'instant', block: 'start' }), 10)
      }
    })
  }

  const handleBlogBackBtn = () => {
    if (blogRepostParent.length > 1 && getCommentsStatus === PENDING) {
      dispatch(getNotificationMessage({
        type: REJECTED,
        message: 'Please finish loading first before returning to previous blog post or comment',
        isEditProfile: true
      }))
    } else {
      const parentData = blogRepostParent[blogRepostParent.length - 1]

      goToHeaderOriginalPos()

      dispatch(setComments([]))
      if (parentData?.parent_type) {
        dispatch(getComments({
          type: parentData.parent_type,
          ...(parentData.parent_type === 'post' ? { post_id: parentData.post_id } : { comment_id: parentData.parent_comment_id })
        }))
      }
    }

    dispatch(setBlogRepostParent(blogRepostParent.slice(0, -1)))
  }

  const GoToMarker = (item, notifDrawerWiden) => {
    dispatch(setHideDrawerAnimation(notifDrawerWiden))
    setTimeout(() => dispatch(setHideDrawerAnimation(false)), 1000)

    const backBtn = document.querySelector('#back-button')
    if (backBtn) {
      document.querySelector('#back-button').click()
    }

    closeDrawer()
    dispatch(setCloseChatModal(true))
    setTimeout(() => dispatch(setCloseChatModal(false)), 300)
    document.querySelector('#blog-modal-overlay').click()

    setTimeout(() => {
      let coord = {
        coord: item?.coordinates,
        isStatic: true
      }
      dispatch(showCurrentChatFriendMarkerCoordinate(coord))

      sessionStorage.setItem('openProfileAfterAnimation', item?.profile_id)
    }, 850)
  }

  const chevronDirection = (type) => {
    if (postsOption.type === 'marker' && !isNotMobile()) {
      if (type === 'icon') {
        return blogRepostParent.length ? 'rotate(180deg)' : 'rotate(270deg)'
      }

      if (type === 'text') {
        return blogRepostParent.length ? 'rotate(-180deg)' : 'rotate(90deg)'
      }
    }

    if (isNotMobile() && type === 'icon') {
      return blogRepostParent.length ? 'rotate(180deg)' : 'rotate(-90deg)'
    }

    if (isNotMobile() && type === 'text') {
      return blogRepostParent.length ? 'rotate(-180deg)' : 'rotate(90deg)'
    }

    return 'rotate(180deg)'
  }

  const closeBlogPreviewDrawer = () => {
    dispatch(setBlogRepostData((blogRepostData || []).slice(0, -1)))
    dispatch(setNewPostsOption([]))
  }

  const transition = {
    type: widenAnimation ? 'tween' : 'spring',
    stiffness: 200,
    damping: 22,
    duration: 0.8
  }
  const animateVariants = {
    WideScreen: {
      initial: {
        width: '368px',
        height: '0px',
        paddingBottom: '20px',
        ...(postsOption.type === 'marker' ? { bottom: '24px' } : {})
      },
      animate: {
        width: shouldWiden() && widenAnimation ? Math.round(window.innerWidth * 0.7) : '368px',
        height: getDrawerHeight(),
        paddingBottom: '0px',
        transition
      },
      exit: {
        padding: '0px',
        width: '368px',
        height: '0px'
      }
    },
    NarrowScreen: {
      initial: {
        width: '95%',
        height: getDrawerHeight(),
        marginRight: '10px',
        x: 450
      },
      animate: {
        x: 0,
        transition
      },
      exit: {
        x: 450,
        marginRight: '-450px'
      }
    },
    NarrowScreenMarker: {
      initial: {
        width: document.querySelector('#marker-popup-container')?.offsetWidth + 3 + 'px' ?? '366px',
        height: '0px',
        bottom: '29px'
      },
      animate: {
        height: getDrawerHeight(),
        transition
      },
      exit: { height: '0px' }
    }
  }

  const handleAnimationVariants = () => {
    if (postsOption.type === 'marker' && !isNotMobile()) {
      return animateVariants.NarrowScreenMarker
    }

    return animateVariants[isNotMobile() ? 'WideScreen' : 'NarrowScreen']
  }

  useEffect(() => {
    setHoveringChevron(false)
  }, [])

  return (
    <StyledMotionBox
      id={`blog-repost-panel-${data?.id}`}
      key={`blog-repost-panel-${data?.id}`}
      variants={handleAnimationVariants()}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{
        type: 'tween',
        duration: 0.8
      }}
      style={{
        translateX: '-50%',
        transformOrigin: 'bottom center'
      }}
      zIndex={postsOption?.type === 'marker' ? 1404 : 1409}
    >
      <Stack
        alignItems="center"
        justifyContent="space-between"
        direction="row"
        p="0px 5px"
        background={COLORS.goldGradientRightToLeft}
        minHeight="48px"
        borderRadius="10px 10px 0 0"
        marginTop="-1px"
        position="sticky"
        top="-0.2"
        zIndex={1050}
      >
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            setWidenAnimation(true)
            setWiden(!widen)

            if (isNotMobile()) {
              dispatch(setHideNotification(!widen))
              dispatch(setHideChat(!widen))
            }

            if (postsOption.type !== 'marker') {
              animateMarkerFilter(false)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          icon={<ResizeIcon />}
          id="resize-button"
          outline="none"
          boxShadow="none"
          display={widen ? 'none' : 'flex'}
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />
        <IconButton
          onClick={(e) => {
            e.stopPropagation()
            setWiden(!widen)

            const notifDrawer = document.querySelector('#NOTIFICATIONS-panel')
            const chatDrawer = document.querySelector('#chat-main-panel')
            const onNarrowScreen = (
              (notifDrawer && notifDrawer.offsetWidth * 3 < document.querySelector('body').offsetWidth)
              || (chatDrawer && chatDrawer.offsetWidth * 3 < document.querySelector('body').offsetWidth)
            )

            if (
              onNarrowScreen
              && isNotMobile()
            ) {
              dispatch(setHideNotification(!widen))
              dispatch(setHideChat(!widen))
            }

            if (
              onNarrowScreen
              && postsOption.type !== 'marker'
            ) {
              animateMarkerFilter(true)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          icon={<ShrinkIcon />}
          id="shrink-button"
          outline="none"
          boxShadow="none"
          display={widen ? 'auto' : 'none'}
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />

        <Text
          maxWidth="70%"
          fontSize="24px"
          textAlign="center"
          textOverflow="ellipsis"
          whiteSpace="nowrap"
          overflow="hidden"
        >
          { data?.full_name + "'s Blog" }
        </Text>

        <IconButton
          onClick={() => {
            if (blogRepostParent.length) {
              handleBlogBackBtn()
            } else {
              closeBlogPreviewDrawer()
            }

            setHoveringChevron(false)
          }}
          onPointerEnter={(e) => {
            if (e.pointerType === 'mouse') {
              setHoveringChevron(true)
            }
          }}
          onPointerLeave={(e) => {
            if (e.pointerType === 'mouse') {
              setHoveringChevron(false)
            }
          }}
          _hover={{ background: COLORS.gold_hover }}
          background="unset"
          transform={chevronDirection('icon')}
          transition="none"
          icon={(
            <>
              <Text
                fontWeight="300"
                transform={chevronDirection('text')}
                display={hoveringChevron ? 'flex' : 'none'}
              >
                {blogRepostParent.length ? 'Back' : 'Exit'}
              </Text>

              <Stack display={hoveringChevron ? 'none' : 'flex'}>
                <ArrowIcon height="15px" />
              </Stack>
            </>
          )}
          id="blog-modal-back-button"
          outline="none"
          boxShadow="none"
          css={{
            ':focus': {
              outline: 'none',
              boxShadow: 'none'
            }
          }}
        />
      </Stack>

      <Stack position="relative">
        {
          getPostsStatus === PENDING
          && blogRepostData?.at(-1)?.id === data.id
            ? (
              <Stack marginTop="100px">
                <LoadingSpinier />
              </Stack>
            )
            : (
              <BlogList
                from={from}
                activeProfile={activeProfile}
                blogParent={blogRepostParent}
                chosenBlogIndex={chosenBlogIndex}
                getPostsStatus={getPostsStatus}
                posts={[data]}
                blogRepostData={blogRepostData}
                blogRepostParent={blogRepostParent}
                postsOption={postsOption}
                profileItem={profileItem}
                chosenNotifBlog={chosenNotifBlog}
                subscribeToProfileStatus={subscribeToProfileStatus}
                adminNotifications={adminNotifications}
                widen={widen}
                setWiden={setWiden}
                GoToMarker={GoToMarker}
                newPostsOption={newPostsOption}
                CommentSection={(
                  <Comments
                    from={from}
                    activeProfile={activeProfile}
                    blogParent={blogRepostParent}
                    blogRepostData={blogRepostData}
                    chosenBlogIndex={chosenBlogIndex}
                    comments={comments}
                    commentsOption={commentsOption}
                    getCommentsStatus={getCommentsStatus}
                    postCommentsStatus={postCommentsStatus}
                    putCommentsStatus={putCommentsStatus}
                    widen={widen}
                    GoToMarker={GoToMarker}
                  />
                )}
              />
            )
        }
      </Stack>
    </StyledMotionBox>
  )
}
